import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/builds/void-zero/clients/mijn-epd/app/layouts/auth.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/builds/void-zero/clients/mijn-epd/app/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/void-zero/clients/mijn-epd/app/layouts/default.vue").then(m => m.default || m))
}